import React, {useEffect, useState} from 'react'
import Dialog from "../../Dialog";
import Tr from "translations/Translations";
import {SignatureType} from "../../../constants/SignatureType";
import Typography from "../../Typography";
import GridBlock from "../../GridBlock";
import GetAppIcon from '@material-ui/icons/GetApp';
import MultiButton, {createButton} from "../../popup/components/MultiButton";
import UploadFile from "../../UploadFile";
import {Link} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import FilesList from "../../FilesList";
import WorkableButton from "../../button/WorkableButton";

const useStyle = makeStyles(theme => ({
    root: {},
    step: {
        marginTop: theme.spacing(2)
    }
}))

const SUPPORTED_SIG_TYPES = [SignatureType.UNKNOWN, SignatureType.E_PUAP];
const isSupportedSigType = (x) => !!x && SUPPORTED_SIG_TYPES.includes(x)

function ExternalSignature(
    {
        config,
        signatureType,
        setSignatureType,
        encryptionRoundId
    }) {
    const classes = useStyle();
    const [file, setFile] = useState(null);
    const [error, setError] = useState(null);
    const [downloadWorking, setDownloadWorking] = useState(false);

    const getButtons = () => {
        const buttons = [];
        buttons.push(createButton(Tr('cancel'), config.cancelCallback, 'outlined'));
        buttons.push(createButton(Tr('confirm'), handlePlaceOffer, undefined));
        return buttons;
    }

    const handleUpload = (upload) => {
        setError(null);
        setFile(upload);
    }

    const handlePlaceOffer = () => {
        setError(null);
        if(!file) {
            setError(Tr("add_file"))
        } else {
            config.successCallback(signatureType, null, file.identity)
        }
    }

    const downloadDocument = () => {
        setDownloadWorking(true);
        config.docContentFunc(signatureType).finally(()=> setDownloadWorking(false))
    }


    return (<Dialog
        maxWidth='md'
        open
        title={Tr("sign_document")}
        dialogActions={<MultiButton buttons={getButtons()}/>}
    >
        <GridBlock column>
            <Typography className={classes.step}>{Tr('signature_external_info_' + signatureType.toLowerCase())}</Typography>

            <WorkableButton working={downloadWorking} Icon={GetAppIcon} onClick={downloadDocument}>{Tr("offer_form_download")}</WorkableButton>

            {
                signatureType === SignatureType.UNKNOWN && <Typography className={classes.step}>{Tr(config.signatureTypes.includes(SignatureType.E_PUAP) ?
                    'signature_external_info_2_unknown_national' : 'signature_external_info_2_unknown_eu')}</Typography>
            }
            {
                signatureType === SignatureType.E_PUAP && <Typography className={classes.step}>{Tr('signature_external_info_2_e_puap')}
                    <Link target="_blank" href={Tr('signature_external_info_2_e_puap_link')}>{Tr('signature_external_info_2_e_puap_link')}</Link>
                </Typography>
            }

            <Typography className={classes.step}>{Tr(signatureType === SignatureType.E_PUAP ? 'signature_external_info_3_e_puap' : 'signature_external_info_3')}</Typography>
            <UploadFile
                multiple={false}
                onUpload={handleUpload}
                onUploadPopupClosed={()=> setError(null)}
                encryptRoundId={encryptionRoundId}
            />
            <FilesList elements={file ? [{file}] : undefined} onDelete={()=> setFile(null)}/>
            {error && <Typography color='error'>{error}</Typography>}
        </GridBlock>
    </Dialog>)


}

ExternalSignature.propTypes = {}

ExternalSignature.defaultProps = {}



function ExternalSignatureWrapper(
    {
        config,
        signatureType,
        setSignatureType
    }) {

    const [supported, setSupported] = useState(false);
    const [encryptionRoundId, setEncryptionRoundId] = useState(undefined);
    useEffect(()=> {
            setSupported(isSupportedSigType(signatureType));
    }, [signatureType])

    useEffect(()=> {
        if(supported) {
            config.getEncryptionRoundId().then(resp => {
                if(resp !== undefined)
                    setEncryptionRoundId(resp);
            })
        } else {
            setEncryptionRoundId(undefined);
        }
        // eslint-disable-next-line
    }, [supported])

    return !!config && encryptionRoundId !== undefined ? <ExternalSignature
        signatureType={signatureType}
        config={config}
        setSignatureType={setSignatureType}
        encryptionRoundId={encryptionRoundId} /> : null

}



export default ExternalSignatureWrapper;
